// extracted by mini-css-extract-plugin
export default {"Pill_Widget":"Pill_Widget_Pill_Widget__A4tJx"};